import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=9815b42e&scoped=true"
import script from "./SidebarContainer.vue?vue&type=script&lang=js"
export * from "./SidebarContainer.vue?vue&type=script&lang=js"
import style0 from "./SidebarContainer.vue?vue&type=style&index=0&id=9815b42e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9815b42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9815b42e')) {
      api.createRecord('9815b42e', component.options)
    } else {
      api.reload('9815b42e', component.options)
    }
    module.hot.accept("./SidebarContainer.vue?vue&type=template&id=9815b42e&scoped=true", function () {
      api.rerender('9815b42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SidebarContainer.vue"
export default component.exports